import { Country } from '@resurs-internal/mui/assets/countries';

import {
  AvailableCountries,
  type AvailableCountry,
  DefaultLanguage,
} from '@/models';

export const getCountry = () => {
  const topLevelDomain = window.location.hostname.split('.').pop();

  const localStorageCountry = localStorage.getItem('country') || undefined;

  return (tdlToAvailableCountry(topLevelDomain) ||
    localStorageCountry ||
    Country.NO) as AvailableCountry;
};

const tdlToAvailableCountry = (tdl?: string): AvailableCountry | undefined => {
  if (tdl && AvailableCountries.includes(tdl.toUpperCase() as AvailableCountry))
    return tdl.toUpperCase() as AvailableCountry;
};

export const defaultLanguageForCountry = (
  country: AvailableCountry,
): string => {
  return DefaultLanguage[country];
};
